import { checkExternalId, updateCustomerAppAccess } from './../apis/customerAPIs';
import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccess } from '../../app/utils/sweetAlert';
import { showSuccessToast } from '../../app/utils/tostify';
import {
	addCustomer,
	deleteCustomer,
	editCustomer,
	getCustomerDetails,
	getCustomerList,
	getPriceList,
	updateCustomerStatus
} from '../apis/customerAPIs';

interface customerState {
	error: any;
	loading: boolean;
	priceList: Array<any>;
	customerList: Array<any>;
	currentPage: number;
	count: number;
	customerDetails: any;
	deviceList: any;
	page: number;
	searchKey: string;
	filter: any;
}

const initialState: customerState = {
	loading: false,
	error: '',
	priceList: [],
	customerList: [],
	currentPage: 1,
	count: 0,
	customerDetails: {},
	deviceList: [],
	page: 0,
	searchKey: '',
	filter: null
};

const customerSlice = createSlice({
	name: 'customerSlice',
	initialState,
	reducers: {
		handlePaginationInCustomer(state, action: any) {
			state.currentPage = action.payload;
		},
		handleSearchKey(state, action: any) {
			state.searchKey = action.payload;
		},
		handleFilter(state, action: any) {
			state.filter = action.payload;
		},
		addDeviceInList(state, action: any) {
			state.deviceList.push(action.payload);
		},
		removeDeviceFromList(state, action: any) {
			state.deviceList.splice(action.payload, 1);
		}
	},
	extraReducers: (builder) => {
		builder.addCase(checkExternalId.fulfilled, (state) => {
			state.loading = false;
		});
		builder.addCase(checkExternalId.rejected, (state) => {
			state.loading = false;
		});
		builder.addCase(getPriceList.pending, (state: customerState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getPriceList.fulfilled,
			(state: customerState, action: any) => {
				state.loading = false;
				state.priceList = action?.payload?.data?.list;
				state.error = '';
			}
		);
		builder.addCase(getPriceList.rejected, (state: customerState) => {
			state.loading = false;
		});
		builder.addCase(getCustomerList.pending, (state: customerState) => {
			state.loading = true;
			state.error = '';
			state.customerDetails = {};
		});
		builder.addCase(
			getCustomerList.fulfilled,
			(state: customerState, action: any) => {
				state.loading = false;
				state.customerList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.deviceList = [];
				state.error = '';
			}
		);
		builder.addCase(getCustomerList.rejected, (state: customerState) => {
			state.loading = false;
		});
		builder.addCase(addCustomer.pending, (state: customerState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addCustomer.fulfilled,
			(state: customerState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addCustomer.rejected, (state: customerState) => {
			state.loading = false;
		});
		builder.addCase(getCustomerDetails.pending, (state: customerState) => {
			state.loading = true;
			state.error = '';
			state.customerDetails = {};
		});
		builder.addCase(
			getCustomerDetails.fulfilled,
			(state: customerState, action: any) => {
				state.loading = false;
				state.error = '';
				state.customerDetails = action?.payload?.data;
				state.deviceList = action?.payload?.data?.device_access;
			}
		);
		builder.addCase(getCustomerDetails.rejected, (state: customerState) => {
			state.loading = false;
		});
		builder.addCase(editCustomer.pending, (state: customerState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			editCustomer.fulfilled,
			(state: customerState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(editCustomer.rejected, (state: customerState) => {
			state.loading = false;
		});
		builder.addCase(deleteCustomer.pending, (state: customerState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			deleteCustomer.fulfilled,
			(state: customerState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(deleteCustomer.rejected, (state: customerState) => {
			state.loading = false;
		});
		builder.addCase(
			updateCustomerStatus.fulfilled,
			(state: customerState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updateCustomerAppAccess.pending, (state: customerState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updateCustomerAppAccess.fulfilled,
			(state: customerState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updateCustomerAppAccess.rejected, (state: customerState) => {
			state.loading = false;
		});
	}
});

export const {
	handlePaginationInCustomer,
	addDeviceInList,
	removeDeviceFromList,
	handleSearchKey,
	handleFilter
} = customerSlice.actions;
export default customerSlice.reducer;
